import { UseExternalRPCQueryOptions, useRPCQuery } from '@/lib/api/request/use-rpc-query';

export type GetDocumentConsentStatusRequest = {
  documentKey: string;
};

export type GetDocumentConsentStatusResponse = {
  documentKey: string;
  hasConsent: boolean;
  signedVersion: string | null;
  activeVersion: string | null;
  isDocumentActive: boolean;
};

export function useGetDocumentConsentStatus({
  params,
  ...opts
}: UseExternalRPCQueryOptions<
  GetDocumentConsentStatusResponse,
  GetDocumentConsentStatusRequest
>) {
  return useRPCQuery({
    ...opts,
    queryKey: ['document-consent-status', params.documentKey, 'ignoreLoading'],
    method: useGetDocumentConsentStatus.method,
    params,
  });
}

useGetDocumentConsentStatus.method = 'user:get-document-consent-status';
